import script from "./FeeReceiptModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FeeReceiptModal.vue?vue&type=script&setup=true&lang=js"

import "./FeeReceiptModal.vue?vue&type=style&index=0&id=5b0cc97b&lang=css"

const __exports__ = script;

export default __exports__